export const INVALID_PHONE_NUMBER = 'Phone number must be 10 digits.';
export const INVALID_NATIONAL_ID = 'National ID must be 16 digits.';
